import { render, staticRenderFns } from "./entityTickets.vue?vue&type=template&id=2c9dcdb0&scoped=true"
import script from "./entityTickets.vue?vue&type=script&lang=js"
export * from "./entityTickets.vue?vue&type=script&lang=js"
import style0 from "./entityTickets.vue?vue&type=style&index=0&id=2c9dcdb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9dcdb0",
  null
  
)

export default component.exports